import { render } from "./DiscoverLayout.vue?vue&type=template&id=9bbccfd6&ts=true"
import script from "./DiscoverLayout.vue?vue&type=script&lang=ts"
export * from "./DiscoverLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__